import Api from './api';

const proformaInvoiceRequest = (carId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/' + carId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const deleteProformaInvoiceRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/proforma/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}
const deleteMultiProformaInvoiceRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/multi-proforma/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}

const proformaExportInPDFRequest = (invoiceId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/pdf/' + invoiceId, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}

const proformaExportInEXCELRequest = (invoiceId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/excel/' + invoiceId, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}

const multiProformaExportInEXCELRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi', {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
        params: query
    })
}
const createShippingMultiproforma = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi/shipping/create', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}
const downloadShippingMultiproforma = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi/shipping', {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
        params: query
    })
}
const downloadShippingMultiproformaInvoices = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi-invoices/shipping/'+id, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob'
    })
}
const downloadMultiproformaPDF = (invoiceId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi-invoices/shipping/pdf/' + invoiceId, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}
const updateProformaInvoiceRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
        return Api().put('/api/proforma/' + data.id , data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const checkProformaInvoiceRequirements = (carId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/check/' + carId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const createNewProformaInvoice = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/proforma/', query , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const saveMultiProformaInvoiceRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/proforma/multi/', data , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const multiProformaInvoices = (user_id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi-proforma/'+user_id , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const multiProformaLatest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi-latest' , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const getMultiProformaRequest = (invoiceId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/proforma/multi/'+invoiceId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const requestUnpaidInvoices = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/proforma/unpaid/'+userId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const requestPayments = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/banking/payments/'+userId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}



export default {
    deleteProformaInvoiceRequest,
    deleteMultiProformaInvoiceRequest,
    proformaInvoiceRequest,
    proformaExportInPDFRequest,
    updateProformaInvoiceRequest,
    proformaExportInEXCELRequest,
    checkProformaInvoiceRequirements,
    createNewProformaInvoice,
    multiProformaExportInEXCELRequest,
    createShippingMultiproforma,
    downloadShippingMultiproforma,
    multiProformaInvoices,
    multiProformaLatest,
    downloadShippingMultiproformaInvoices,
    downloadMultiproformaPDF,
    getMultiProformaRequest,
    saveMultiProformaInvoiceRequest,
    requestUnpaidInvoices,
    requestPayments
}



// WEBPACK FOOTER //
// ./src/api/apiProformaInvoices.js